/**
 * App-wide page ease-in.
 *
 * Applied by the layout routes (`_authenticated/route.tsx`, `_public.tsx`)
 * around their <Outlet />, keyed by pathname: every navigation (including
 * back) remounts the wrapper and replays the fade, while search-only changes
 * keep the key and do not re-fade. The bottom navigation sits OUTSIDE the
 * wrapper in the authed shell, so it never re-fades.
 *
 * OPACITY ONLY: a transform on this container would make it the containing
 * block for the root wash's position:fixed layers (__root.module.less) and
 * break their viewport-anchored mask.
 */
@import '@/styles/mixins/index.less';

.pageEaseIn {
  .animate-fade-in(0.25s, ease-out);
}

// Splash-module pattern: reduced-motion users get the page instantly, no fade.
@media (prefers-reduced-motion: reduce) {
  .pageEaseIn {
    animation: none;
  }
}
